import profit from '@js/store/modules/profit';

export default {
    created() {
        if (!this.$store.hasModule('profit')) {
            this.$store.registerModule('profit', profit);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/profit/profit-mixin.js